module.exports = __webpack_public_path__ + "img/profile.46b82019.jpg";